import React, { Component } from "react";

class StatusDescription extends Component {
  statusDescription = (status) => {
    if ("Accounting Hold" === status) {
      return "Pending";
    }
    return status;
  };

  render() {
    const { order } = this.props;
    const cellStyle =
      "status-description row-item tw-no-underline tw-self-start tw-text-left row-value";
    const statusText = order.orderStatus?.value || order.statusDesc;

    return (
      <div className={cellStyle} style={{ alignSelf: "center" }}>
        {this.statusDescription(statusText)}
      </div>
    );
  }
}

export default StatusDescription;
